import { SxProps, Theme, lighten } from "@mui/material";

import { stringToColor } from "./color";

export type AvatarSize = "extraSmall" | "small" | "medium" | "large" | "extraLarge";

export function getAvatarSizeSx(size: AvatarSize = "medium"): SxProps {
  return {
    fontSize: {
      extraSmall: "9px",
      small: "11px",
      medium: "13px",
      large: "15px",
      extraLarge: "17px",
    }[size],
    height: {
      extraSmall: 18,
      small: 22,
      medium: 30,
      large: 35,
      extraLarge: 40,
    }[size],
    width: {
      extraSmall: 18,
      small: 22,
      medium: 30,
      large: 35,
      extraLarge: 40,
    }[size],
  };
}

export default function stringAvatar(name: string, size: AvatarSize = "medium") {
  const [firstWord, secondWord] = !name ? ["", ""] : name.split(" ");

  let initials: string;
  if (firstWord && secondWord) {
    initials = firstWord.substring(0, 1);
    initials += secondWord.substring(0, 1);
  } else if (firstWord && !secondWord) {
    initials = firstWord.substring(0, 2);
  } else {
    initials = "N/A";
  }
  return {
    sx: {
      color: (theme: Theme) => `${theme.palette.getContrastText(stringToColor(name ?? ""))} !important`,
      bgcolor: lighten(stringToColor(name ?? ""), 0.5),
      fontWeight: 500,
      ...getAvatarSizeSx(size),
    },
    children: initials.toUpperCase(),
  };
}
